module.exports = __webpack_public_path__ + "static/img/logo-header.7d2d437d.png";